import { render } from "./AgreementModal.vue?vue&type=template&id=4dc64530&ts=true"
import script from "./AgreementModal.vue?vue&type=script&lang=ts"
export * from "./AgreementModal.vue?vue&type=script&lang=ts"

import "./AgreementModal.vue?vue&type=style&index=0&id=4dc64530&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QSeparator});
